'use client';

import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useCallback } from 'react';
import { useNavigate } from '../../common/hooks/useNavigate';

/**
 * 브랜드 스토어 홈 진입 — 상품 카드 브랜드명 클릭 시 새 웹뷰로 스토어 홈을 연다. (QAT-39448)
 *
 * - 무신사: `${NEXT_PUBLIC_MUSINSA_BASE_URL}/brand/{brandId}`
 * - 29CM:  `${NEXT_PUBLIC_29CM_BASE_URL}/store/brand/{brandId}`
 *
 * `brandId` 는 BE `campaign.brandId`(플랫폼별 식별자 — 무신사 코드 '032c' / 29CM brandNo).
 * 시딩은 단일 브랜드 캠페인이라 캠페인 브랜드 = 상품 브랜드이므로 캠페인 brandId 를 그대로 쓴다.
 * base URL 은 환경변수라 개발/운영 자동 전환된다.
 */
export const useBrandStoreNavigation = () => {
  const { navigate } = useNavigate();
  const { service } = useDeviceInfo();

  return useCallback(
    (brandId: string) => {
      if (!brandId) return;
      const is29cm = service === SERVICE['29CM'];
      const url = is29cm
        ? `${process.env.NEXT_PUBLIC_29CM_BASE_URL}/store/brand/${brandId}`
        : `${process.env.NEXT_PUBLIC_MUSINSA_BASE_URL}/brand/${brandId}`;
      // 새 웹뷰로 열기. 29CM 인앱은 native 앱바 노출 위해 fullscreen 쿼리 끔(useProductLinkNavigation 동일 패턴).
      navigate(url, { newWebview: true, disableFullscreen: is29cm });
    },
    [navigate, service],
  );
};
